import { ProspectoCab } from './../../../models/ProspectoCab';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { FiltrosProspecto } from 'app/models/FiltrosProspecto';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from "rxjs";
import { filter, pluck } from "rxjs/operators";
import { LocalService } from '../../storage/localService';

@Injectable({
  providedIn: 'root'
})
export class ProspectosService {
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  idEmpresa_Factor: any;
  message: Observable<any>;
  prospecto: ProspectoCab;

  constructor(private http: HttpClient, private accesoService: AccesoService, private sessionStorageService: SessionStorageService, private localService: LocalService) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage()
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  obtenerProspectoCab(Filtros: FiltrosProspecto) {
    let headers = this.header;
    return this.http.get<ProspectoCab[]>(`${this.urlBase}/ObtenerProspectosCab?idEmpresa_Factor=${this.idEmpresa_Factor}&idProspecto=${Filtros.idPros}&ruc=${Filtros.rucAdqui}&FechaInicial=${Filtros.FechaIni}&FechaFinal=${Filtros.FechaFin}&Estado=${Filtros.Estado}&Version=${Filtros.Version}&User=${Filtros.user_id}`, { headers });
  }

  crearProspectoCab(bodyProspectoCab: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CrearProspectoCab?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyProspectoCab, { headers });
  }

  evaluarProspecto(data: any) {    
    let headers = this.header;
    return this.http.put(`${this.urlBase}/EvaluarProspectoCab?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });     
  }

  reeevaluarProspecto(data: any) {    
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ReevaluarProspectoCab?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });     
  }

  darBajaProspectoCab(idProspectoCab: number, bodyProspectoCab: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/BajaProspectoCab?idEmpresa_Factor=${this.idEmpresa_Factor}&idProspecto=${idProspectoCab}`, bodyProspectoCab, { headers });
  }

  editarMontoRiesgoPropuesta(data: any) {    
    let headers = this.header;
    return this.http.put(`${this.urlBase}/ActualizarProspectoXPropuesta?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });     
  }
}